<div class="list-container">
    <rask-list [data]="terminalordrar" [getSelectedFromRoute]="true">
        <rask-list-column header="{{ 'TERMINALORDER_LIST_HEADER_MOTTAGNINGSPLATS' | translate }}" field="namn"
            [sortable]="true" [nowrap]="true" width="30%">
            <ng-template let-row="row">
                <a [routerLink]="['/terminalorder', row.id]">
                    {{ row.namn }}
                </a>
            </ng-template>
        </rask-list-column>
        <rask-list-column header="{{ 'KUNDORDER_LIST_PERIODFROM' | translate }}" field="periodFrom" [sortable]="true"
            [nowrap]="true" width="110px"></rask-list-column>
        <rask-list-column header="{{ 'KUNDORDER_LIST_PERIODTOM' | translate }}" field="periodTom" [sortable]="true"
            [nowrap]="true" width="100px"></rask-list-column>
        <rask-list-column header="{{ 'KUNDORDER_LIST_ORDERNUMMER' | translate }}" field="ordernummer" [sortable]="true"
            [nowrap]="true" width="120px"></rask-list-column>
        <rask-list-column header="{{ 'KUNDORDER_LIST_HANDELSSORTIMENT' | translate }}" [nowrap]="true"
            field="handelssortiment" [sortable]="true" [tooltip]="true"></rask-list-column>
        <rask-list-column header="{{ 'KUNDORDER_LIST_KVANTITET' | translate }}" field="kvantitet" [sortable]="true"
            [nowrap]="true"></rask-list-column>
        <rask-list-column header="{{ 'KUNDORDER_LIST_AVTALSANSVARIG' | translate }}" field="avtalsansvarig"
            [sortable]="true" [nowrap]="true"></rask-list-column>
        <rask-list-column header="{{ 'KUNDORDER_LIST_BESKRIVNING' | translate }}" field="beskrivning" [sortable]="true"
            [nowrap]="true" width="15%" [tooltip]="true"></rask-list-column>
    </rask-list>
</div>